/*
 * @Descripttion:
 * @version:
 * @Author: TangXihao
 * @Date: 2020-12-10 14:31:32
 * @LastEditors: TangXihao
 * @LastEditTime: 2021-07-01 10:33:45
 */
import React, { Component } from "react";
import moment from 'moment'
import "./index.css";
import { connect } from 'react-redux'
import { Table } from "antd";
import Template from "../template";
import icon_property from '../img/icon_property.png'
import icon_personaldata from '../img/icon_personaldata.png'
import icon_password from '../img/icon_password.png'


import axios from "axios";
import { message } from "antd";
import { Link } from "react-router-dom";

let columns = [
    {
        title: "登录方式",
        dataIndex: "loginMode",
        key: "loginMode",
        render: (_, data) => (
            <div>{data.loginType}</div>
        ),
    },
    // {
    //   title: "登录IP",
    //   dataIndex: "equipmentName",
    //   key: "equipmentName",
    //   render: (_, data) => (
    //     <div>{data.loginIP}</div>
    //   ),
    // },
    {
        title: "登录系统",
        dataIndex: "system",
        key: "system",
        render: (_, data) => (
            <div>{data.systemName}</div>
        ),
    },
    {
        title: "登录时间",
        dataIndex: "loginTime",
        key: "loginTime",
        render: (_, data) => (
            <div>{moment(data.operaTime).format("YYYY-MM-DD HH:mm:ss")}</div>
        ),
    },
];

const cardList = [
    {
        title: '身份认证',
        linkTitle: '前往认证>',
        placeholder: '实名认证后开启更多功能',
        icon: icon_property,
        // link: "/usercenter/myorder"
    },
    {
        title: '个人简介',
        linkTitle: '前往修改>',
        placeholder: '修改资料让大家更了解你',
        icon: icon_personaldata,
        link: "/usercenter/myaccount/changePersonalInfo"
    },
    {
        title: '修改密码',
        linkTitle: '前往修改>',
        placeholder: '定期修改密码，提高账户安全性',
        icon: icon_password,
        link: "/usercenter/myaccount/changePassword"
    }
]


class MyAccount extends Component {
    state = {
        tab: 1,
        // dataSource: loginLog,
        //表格数据总数
        limitCount: 6,//每页数量
        total: 0,

        loading: true,

        //存储数据列表
        numList: [],
    };

    componentDidMount() {
        // this.getNumList(this.state.tab)
        // debugger
        this.getLoginLogs(1);
    }

    componentDidUpdate(preProps) {
        if (preProps.user.userId !== this.props.user.userId) {
            this.getLoginLogs(1);
        }
    }

    getLoginLogs = async (page) => {
        const { limitCount } = this.state;
        const { user } = this.props;
        // const { data: ref } = await axios.get(`${window.url.sys}/sys/user/getLoginInfo?page=${page}&limit=${limitCount}&userId=${user.userId}`);
        // const { data: ref } = await axios.get(`${window.yunguanDateSearch}/log/login/pageList?logLevel=${'INFO'}&loginAccount=${user.userName}&pageNum=${page}&pageSize=${limitCount}`);
        const { data: ref } = await axios.get(`https://caplos.aircas.ac.cn/ygOldLog/log/login/pageList?logLevel=${'INFO'}&loginAccount=${user.userName}&pageNum=${page}&pageSize=${limitCount}&systemName=${'应用技术集成与共享'}`);
        // const { data: ref } = await axios.get(`https://caplos.aircas.ac.cn/ygOldLog/log/login/pageList?logLevel=${'INFO'}&loginAccount=${user.userName}&pageNum=${page}&pageSize=${limitCount}`);

        //startTime endTime loginIP//这些属性暂时未用到

        // console.log(ref.code)

        if (ref.code !== 0) {
            return message.error("获取数据失败！！！！");
        }
        ref.rows.map((e) => {
            // console.log(e)
            e.key = e.id;
        });
        console.log('检查登录记录:', ref);
        this.setState({
            total: ref.total,
            numList: ref.rows,
        });
    };

    changePage = (current) => {
        // debugger
        //setState是异步的，因此在调用getLoginLogs时要用回调函数的形式
        // this.setState({
        //   page: current,
        // },() => this.getLoginLogs() );

        this.getLoginLogs(current)
    };

    ontabchange = (tab) => {
        switch (tab) {
            case 1:
                columns = [
                    {
                        title: "登录方式",
                        dataIndex: "loginMode",
                        key: "loginMode",
                    },
                    {
                        title: "浏览器版本",
                        dataIndex: "equipmentName",
                        key: "equipmentName",
                    },
                    {
                        title: "系统",
                        dataIndex: "system",
                        key: "system",
                    },
                    {
                        title: "登录时间",
                        dataIndex: "loginTime",
                        key: "loginTime",
                        render: (_, data) => (
                            // <div>{moment(data.loginTime).format("YYYY-MM-DD HH:mm:ss") + "aaaa"}</div>
                            <div>{"aaaa"}</div>
                        ),
                    },
                ];
                break;
            case 2:
                columns = [
                    {
                        title: "名称",
                        dataIndex: "loginMode",
                        key: "loginMode",
                    },
                    {
                        title: "类型",
                        dataIndex: "equipmentName",
                        key: "equipmentName",
                    },
                    {
                        title: "事件数",
                        dataIndex: "system",
                        key: "system",
                    },
                    {
                        title: "大小",
                        dataIndex: "loginTime",
                        key: "loginTime",
                    },
                ];
                break;
            default:
                break;
        }
        this.setState({ tab });
        // this.getNumList(tab)
    };


    render() {
        return (
            <Template title="我的账户">
                <div className={"usercenter-myaccount-top-backpanel"}>
                    {
                        cardList.map((item, index) => {
                            return (
                                <Link to={item.link}>
                                    <div className="usercenter-myaccount-card">
                                        <img className="usercenter-myaccount-card-avatar" src={item.icon}></img>
                                        <div className="usercenter-myaccount-card-container">
                                            <div className="usercenter-myaccount-card-title">{item.title}</div>
                                            <div className="usercenter-myaccount-card-linkTitle">{item.linkTitle}</div>
                                            <div
                                                className="usercenter-myaccount-card-placeholder">{item.placeholder}</div>
                                        </div>
                                    </div>
                                </Link>
                            )
                        })
                    }
                </div>
                <div className={"usercenter-mycoin-coinchange-backpanel"}>
                    <div className={'usercenter-mycoin-table'}>
                        <div className="usercenter-mycoin-table-title">登录记录</div>
                        <Table
                            pagination={{
                                showSizeChanger: false,
                                showQuickJumper: false,
                                showTotal: () => `共${this.state.total}条`,
                                pageSize: 6,
                                //   current: this.state.page,
                                total: this.state.total,
                                onChange: (current) => this.changePage(current),
                                style: { margin: '5px 0' }
                            }}
                            scroll
                            dataSource={this.state.numList}
                            columns={columns}
                            className="usercenter-mycoin-table-body"
                        />
                    </div>
                </div>
            </Template>
        );
    }
}

const mapState = (state) => ({
    user: state.userReducer.get('user').toJS()
})
const mapDispatch = (dispatch) => ({})

export default connect(mapState, mapDispatch)(MyAccount);
